import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.subjects');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-subjects',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.subjects/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}`],
})
export class PageAdminSubjectsComponent implements OnInit {
    public subjects: any[] = [];
    public loading: boolean = true;

    // 과목 편집
    public editSubject: any = null;
    public newSubject: any = { name: '', description: '', sort_order: 0 };
    public showNewSubject: boolean = false;

    // 대단원 편집
    public editChapter: any = null;
    public newChapter: any = { subject_id: '', title: '', description: '', grade_level: 'high', sort_order: 0 };
    public showNewChapter: string = ''; // subject_id

    // 소단원 편집
    public editTopic: any = null;
    public newTopic: any = { chapter_id: '', title: '', description: '', sort_order: 0 };
    public showNewTopic: string = ''; // chapter_id

    public gradeLevels = [
        { value: 'middle2', label: '중2' },
        { value: 'middle3', label: '중3' },
        { value: 'high', label: '고등' },
        { value: 'suneung', label: '수능' }
    ];

    // 펼침 상태
    public expandedSubjects: any = {};
    public expandedChapters: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list");
        if (code === 200) {
            this.subjects = data.subjects || [];
        }

        this.loading = false;
        await this.service.render();
    }

    public toggleSubject(id: string) {
        this.expandedSubjects[id] = !this.expandedSubjects[id];
        this.service.render();
    }

    public toggleChapter(id: string) {
        this.expandedChapters[id] = !this.expandedChapters[id];
        this.service.render();
    }

    public gradeLevelLabel(value: string): string {
        const found = this.gradeLevels.find(g => g.value === value);
        return found ? found.label : value;
    }

    // ===== 과목 CRUD =====
    public async saveSubject() {
        const { code } = await wiz.call("create_subject", this.newSubject);
        if (code === 200) {
            this.showNewSubject = false;
            this.newSubject = { name: '', description: '', sort_order: 0 };
            await this.load();
        }
    }

    public startEditSubject(s: any) {
        this.editSubject = { ...s };
        this.service.render();
    }

    public async updateSubject() {
        const { code } = await wiz.call("update_subject", this.editSubject);
        if (code === 200) {
            this.editSubject = null;
            await this.load();
        }
    }

    public async deleteSubject(id: string) {
        const res = await this.service.modal.show({
            title: '과목 삭제',
            message: '이 과목과 하위 단원이 모두 삭제됩니다. 계속하시겠습니까?',
            action: '삭제',
            status: 'error',
            actionBtn: 'error'
        });
        if (!res) return;
        await wiz.call("delete_subject", { id });
        await this.load();
    }

    // ===== 대단원 CRUD =====
    public openNewChapter(subjectId: string) {
        this.showNewChapter = subjectId;
        this.newChapter = { subject_id: subjectId, title: '', description: '', grade_level: 'high', sort_order: 0 };
        this.service.render();
    }

    public async saveChapter() {
        const { code } = await wiz.call("create_chapter", this.newChapter);
        if (code === 200) {
            this.showNewChapter = '';
            await this.load();
        }
    }

    public startEditChapter(ch: any) {
        this.editChapter = { ...ch };
        this.service.render();
    }

    public async updateChapter() {
        const { code } = await wiz.call("update_chapter", this.editChapter);
        if (code === 200) {
            this.editChapter = null;
            await this.load();
        }
    }

    public async deleteChapter(id: string) {
        const res = await this.service.modal.show({
            title: '대단원 삭제',
            message: '이 대단원과 하위 소단원이 모두 삭제됩니다.',
            action: '삭제',
            status: 'error',
            actionBtn: 'error'
        });
        if (!res) return;
        await wiz.call("delete_chapter", { id });
        await this.load();
    }

    // ===== 소단원 CRUD =====
    public openNewTopic(chapterId: string) {
        this.showNewTopic = chapterId;
        this.newTopic = { chapter_id: chapterId, title: '', description: '', sort_order: 0 };
        this.service.render();
    }

    public async saveTopic() {
        const { code } = await wiz.call("create_topic", this.newTopic);
        if (code === 200) {
            this.showNewTopic = '';
            await this.load();
        }
    }

    public startEditTopic(t: any) {
        this.editTopic = { ...t };
        this.service.render();
    }

    public async updateTopic() {
        const { code } = await wiz.call("update_topic", this.editTopic);
        if (code === 200) {
            this.editTopic = null;
            await this.load();
        }
    }

    public async deleteTopic(id: string) {
        const res = await this.service.modal.show({
            title: '소단원 삭제',
            message: '이 소단원을 삭제하시겠습니까?',
            action: '삭제',
            status: 'error',
            actionBtn: 'error'
        });
        if (!res) return;
        await wiz.call("delete_topic", { id });
        await this.load();
    }

    // ===== 시드 데이터 =====
    public async seedData() {
        const res = await this.service.modal.show({
            title: '시드 데이터 생성',
            message: '과목(한국사/세계사/동아시아사)과 표준 대단원 구조를 생성합니다.',
            action: '생성',
            status: 'success',
            actionBtn: 'success'
        });
        if (!res) return;
        const { code } = await wiz.call("seed");
        if (code === 200) {
            await this.load();
        }
    }
}

export default PageAdminSubjectsComponent;